import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"

const NoteButton: React.FC<{
  openNotaModal: () => void
  hasNote: boolean
}> = ({ openNotaModal, hasNote }) => {
  return (
    <div
      className='tw-grid tw-place-content-center tw-cursor-pointer tw-size-10 tw-rounded-md'
      onClick={openNotaModal}
    >
      <FontAwesomeIcon
        icon={["fal", "sticky-note"]}
        className='tw-text-black data-[has-note=true]:tw-text-warning tw-size-5'
        data-has-note={hasNote}
      />
    </div>
  )
}

export default NoteButton
